//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'StepItemHorizontal',
  props: {
    heading: {
      type: String,
      required: true,
    },
    icon: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
};
